/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './cluster/cluster.component';
import {ClusterManagerFilter} from './cluster-manager.filter';
import {ClusterManagerService} from './cluster-manager.service';

angular.module('zeppelinWebApp')
  .controller('ClusterManagerCtrl', ClusterManagerController)
  .filter('ClusterManager', ClusterManagerFilter)
  .service('ClusterManagerService', ClusterManagerService);

function ClusterManagerController($scope, ngToast, ClusterManagerFilter, ClusterManagerService) {
  'ngInject';

  $scope.clustersLoaded = false;
  $scope.clusters = [];
  $scope.filteredClusters = $scope.clusters;
  $scope.filterConfig = {
    text: '',
    state: '*',
    isSortByAsc: true,
  };

  $scope.pagination = {
    currentPage: 1,
    itemsPerPage: 10,
    maxPageCount: 5,
  };
  $scope.settingCurrentCluster = false;

  ngToast.dismiss();

  /** functions */

  $scope.getClustersInCurrentPage = function(clusters) {
    const cp = $scope.pagination.currentPage;
    const itp = $scope.pagination.itemsPerPage;
    return clusters.slice((cp - 1) * itp, (cp * itp));
  };

  $scope.filterClusters = function(clusters, filterConfig) {
    // eslint-disable-next-line new-cap
    $scope.filteredClusters = ClusterManagerFilter(clusters, filterConfig);
  };

  $scope.stateFilterValueToName = function(filterValue) {
    if (typeof $scope.states === 'undefined') {
      return;
    }

    let index = $scope.states.findIndex((state) => state.value === filterValue);
    if (index >= 0 && $scope.states[index]) {
      return $scope.states[index].name;
    }
  };

  $scope.setStateFilterValue = function(filterValue) {
    $scope.filterConfig.state = filterValue;
    $scope.filterClusters($scope.clusters, $scope.filterConfig);
  };

  const onCurrentClusterChange = function(currentCluster) {
    $scope.currentCluster = currentCluster;
    if (currentCluster) {
      $scope.currentClusterLabel = currentCluster.name;
    } else {
      $scope.currentClusterLabel = 'None';
    }
  };

  $scope.setCurrentCluster = function(currentCluster) {
    // construct log messages
    let confirmationMessage;
    let confirmationTitle;
    let successMessage;
    let currentClusterName;
    if (currentCluster) {
      currentClusterName = currentCluster.name;
      confirmationTitle = 'Set Current Cluster';
      confirmationMessage = `Set your current cluster to ${currentClusterName}?`;
      successMessage = `Set current cluster to: ${currentClusterName}.`;
    } else {
      confirmationTitle = 'Unset Current Cluster';
      confirmationMessage = 'Unset your current cluster?';
      successMessage = 'Unset current cluster.';
    }

    // ask the user to confirm
    BootstrapDialog.confirm({
      closable: true,
      title: confirmationTitle,
      message: confirmationMessage,
      callback: (ok) => {
        if (!ok) {
          // no confirmation, so just return
          return;
        }

        // make the request
        $scope.settingCurrentCluster = true;
        ClusterManagerService.setCurrentCluster(currentClusterName)
          .then(() => {
            // success
            onCurrentClusterChange(currentCluster);
            ngToast.info(successMessage);
          }, (response) => {
            // failure
            const message = (response.data && response.data.message)
              ? response.data.message : 'Server Error';
            ngToast.danger(message);
          })
          .finally(() => {
            // always unset loading flag after we're done
            $scope.settingCurrentCluster = false;
          });
      },
    });
  };

  ClusterManagerService.getClusters()
    .then((response) => {
      // parse the response
      const summary = response.data;
      const clusters = summary.clusters;
      const currentClusterId = summary.currentClusterId;

      // determine the current cluster
      const currentCluster = _.find(clusters, (c) => c.clusterId === currentClusterId);
      onCurrentClusterChange(currentCluster);

      // set current clusters
      $scope.clusters = clusters;

      // parse the cluster states
      let states = $scope.clusters
        .map((j) => j.state);
      states = [...new Set(states)]; // remove duplicated states

      $scope.states = [{name: 'ALL', value: '*'}];
      for (let i = 0; i < states.length; i++) {
        $scope.states.push({name: states[i], value: states[i]});
      }

      // apply any filters
      $scope.filterClusters(clusters, $scope.filterConfig);

      // signal that the clusters have been loaded
      $scope.clustersLoaded = true;
    })
    .catch((response) => {
      const message = (response.data && response.data.message)
        ? response.data.message : 'Error loading clusters';
      ngToast.danger(message);
    });
}



// WEBPACK FOOTER //
// ./src/app/clusters/cluster-manager.component.js